import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from "react";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
interface ClosedButtonProps {
  readonly loading?: boolean | undefined;
  readonly children: React.ReactNode;
  readonly padding?: string | undefined;
  readonly title?: string | undefined;
  readonly className?: string | undefined;
  readonly fullWidth?: boolean | undefined;
}

/**
 * Gray button component for closed/ended states
 * Follows the same pattern as other button components
 */
export default function ClosedButton(t0) {
  const $ = _c(7);
  const {
    loading: t1,
    children,
    padding: t2,
    title,
    className: t3,
    fullWidth: t4
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const padding = t2 === undefined ? "tw-px-2.5 tw-py-2" : t2;
  const className = t3 === undefined ? "" : t3;
  const fullWidth = t4 === undefined ? true : t4;
  const widthClasses = fullWidth ? "tw-w-full" : "tw-w-auto";
  const t5 = `tw-flex ${widthClasses} tw-items-center tw-justify-center tw-gap-x-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-iron-600 tw-bg-iron-700 tw-text-iron-300 ${padding} tw-text-sm tw-font-medium tw-opacity-75 tw-transition tw-duration-200 tw-ease-out ${className}`;
  let t6;
  if ($[0] !== loading) {
    t6 = loading && <CircleLoader />;
    $[0] = loading;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== children || $[3] !== t5 || $[4] !== t6 || $[5] !== title) {
    t7 = <button disabled={true} type="button" title={title} aria-label={title} className={t5}>{t6}{children}</button>;
    $[2] = children;
    $[3] = t5;
    $[4] = t6;
    $[5] = title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}